import { IonContent, IonPage } from '@ionic/react';
import React from 'react';

import { Logo, Padding, PageMeta } from '@/components/common';

import './Legal.css';

const PrivacyPolicy = () => {
  return (
    <IonPage>
      <PageMeta title="Privacy Policy - Odonto" />
      <IonContent>
        <Padding>
          <Logo navigateToRootOnClick />
          <div className="container">
            <h1 className="legal__title">PRIVACY POLICY</h1>
            <p className="legal__paragraph">Effective date: 09/23/2024</p>
            <h2 className="legal__section-title">1. Introduction</h2>
            <p className="legal__paragraph">Welcome to Odonto</p>
            <p className="legal__paragraph">
              Odonto (“us”, “we”, or “our”) operates https://www.odonto.ph
              (hereinafter referred to as “Service”).
            </p>
            <p className="legal__paragraph">
              Our Privacy Policy governs your visit to https://www.odonto.ph,
              and explains how we collect, safeguard and disclose information
              that results from your use of our Service.
            </p>
            <p className="legal__paragraph">
              We use your data to provide and improve Service. By using Service,
              you agree to the collection and use of information in accordance
              with this policy. Unless otherwise defined in this Privacy Policy,
              the terms used in this Privacy Policy have the same meanings as in
              our Terms and Conditions.
            </p>
            <p className="legal__paragraph">
              Our Terms and Conditions (“Terms”) govern all use of our Service
              and together with the Privacy Policy constitutes your agreement
              with us (“agreement”).
            </p>
            <h2 className="legal__section-title">2. Definitions</h2>
            <p className="legal__paragraph">
              SERVICE means the https://www.odonto.ph website operated by Odonto
            </p>
            <p className="legal__paragraph">
              PERSONAL DATA means data about a living individual who can be
              identified from those data (or from those and other information
              either in our possession or likely to come into our possession).
            </p>
            <p className="legal__paragraph">
              USAGE DATA is data collected automatically either generated by the
              use of Service or from Service infrastructure itself (for example,
              the duration of a page visit).
            </p>
            <p className="legal__paragraph">
              COOKIES are small files stored on your device (computer or mobile
              device).
            </p>
            <p className="legal__paragraph">
              DATA CONTROLLER means a natural or legal person who (either alone
              or jointly or in common with other persons) determines the
              purposes for which and the manner in which any personal data are,
              or are to be, processed. For the purpose of this Privacy Policy,
              we are a Data Controller of your data.
            </p>
            <p className="legal__paragraph">
              DATA PROCESSORS (OR SERVICE PROVIDERS) means any natural or legal
              person who processes the data on behalf of the Data Controller. We
              may use the services of various Service Providers in order to
              process your data more effectively.
            </p>
            <p className="legal__paragraph">
              DATA SUBJECT is any living individual who is the subject of
              Personal Data.
            </p>
            <p className="legal__paragraph">
              THE USER is the individual using our Service. The User corresponds
              to the Data Subject, who is the subject of Personal Data.
            </p>
            <h2 className="legal__section-title">
              3. Information Collection and Use
            </h2>
            <p className="legal__paragraph">
              We collect several different types of information for various
              purposes to provide and improve our Service to you.
            </p>
            <h2 className="legal__section-title">4. Types of Data Collected</h2>
            <h3 className="legal__sub-section-title">Personal Data</h3>
            <p className="legal__paragraph">
              While using our Service, we may ask you to provide us with certain
              personally identifiable information that can be used to contact or
              identify you (“Personal Data”). Personally identifiable
              information may include, but is not limited to:
            </p>
            <ul className="list">
              <li className="list-item">First name and last name</li>
              <li className="list-item">Phone number</li>
              <li className="list-item">Cookies and Usage Data</li>
            </ul>
            <h3 className="legal__sub-section-title">Usage Data</h3>
            <p className="legal__paragraph">
              We may also collect information that your browser sends whenever
              you visit our Service or when you access Service by or through a
              mobile device (“Usage Data”).
            </p>
            <p className="legal__paragraph">
              This Usage Data may include information such as your computer's
              Internet Protocol address (e.g. IP address), browser type, browser
              version, the pages of our Service that you visit, the time and
              date of your visit, the time spent on those pages, unique device
              identifiers and other diagnostic data.
            </p>
            <p className="legal__paragraph">
              When you access Service with a mobile device, this Usage Data may
              include information such as the type of mobile device you use,
              your mobile device unique ID, the IP address of your mobile
              device, your mobile operating system, the type of mobile Internet
              browser you use, unique device identifiers and other diagnostic
              data.
            </p>
            <h3 className="legal__sub-section-title">Tracking Cookies Data</h3>
            <p className="legal__paragraph">
              We use cookies and similar tracking technologies to track the
              activity on our Service and we hold certain information.
            </p>
            <p className="legal__paragraph">
              Cookies are files with a small amount of data which may include an
              anonymous unique identifier. Cookies are sent to your browser from
              a website and stored on your device. Other tracking technologies
              are also used such as beacons, tags and scripts to collect and
              track information and to improve and analyze our Service.
            </p>
            <p className="legal__paragraph">
              You can instruct your browser to refuse all cookies or to indicate
              when a cookie is being sent. However, if you do not accept
              cookies, you may not be able to use some portions of our Service.
            </p>
            <p className="legal__paragraph">Examples of Cookies we use:</p>
            <ul className="list">
              <li className="list-item">
                Session Cookies: We use Session Cookies to operate our Service.
              </li>
              <li className="list-item">
                Preference Cookies: We use Preference Cookies to remember your
                preferences and various settings.
              </li>
              <li className="list-item">
                Security Cookies: We use Security Cookies for security purposes.
              </li>
              <li className="list-item">
                Advertising Cookies: Advertising Cookies are used to serve you
                with advertisements that may be relevant to you and your
                interests.
              </li>
            </ul>
            <h2 className="legal__section-title">5. Use of Data</h2>
            <p className="legal__paragraph">
              Odonto uses the collected data for various purposes:
            </p>
            <ul className="list">
              <li className="list-item">
                to provide and maintain our Service;
              </li>
              <li className="list-item">
                to notify you about changes to our Service;
              </li>
              <li className="list-item">
                to allow you to participate in interactive features of our
                Service when you choose to do so;
              </li>
              <li className="list-item">to provide customer support;</li>
              <li className="list-item">
                to gather analysis or valuable information so that we can
                improve our Service;
              </li>
              <li className="list-item">
                to monitor the usage of our Service;
              </li>
              <li className="list-item">
                to detect, prevent and address technical issues;
              </li>
              <li className="list-item">
                to fulfill any other purpose for which you provide it;
              </li>
              <li className="list-item">
                to carry out our obligations and enforce our rights arising from
                any contracts entered into between you and us, including for
                billing and collection;
              </li>
              <li className="list-item">
                to provide you with notices about your account and/or
                subscription, including expiration and renewal notices,
                email-instructions, etc.;
              </li>
              <li className="list-item">
                to provide you with news, special offers and general information
                about other goods, services and events which we offer that are
                similar to those that you have already purchased or enquired
                about unless you have opted not to receive such information;
              </li>
              <li className="list-item">
                to send you SMS notifications and reminders for your
                appointments;
              </li>
              <li className="list-item">
                to display your contact information so patients can reschedule
                or cancel their appointments;
              </li>
              <li className="list-item">
                in any other way we may describe when you provide the
                information;
              </li>
              <li className="list-item">
                for any other purpose with your consent.
              </li>
            </ul>
            <h2 className="legal__section-title">6. Retention of Data</h2>
            <p className="legal__paragraph">
              We will retain your Personal Data only for as long as is necessary
              for the purposes set out in this Privacy Policy. We will retain
              and use your Personal Data to the extent necessary to comply with
              our legal obligations (for example, if we are required to retain
              your data to comply with applicable laws), resolve disputes, and
              enforce our legal agreements and policies.
            </p>
            <p className="legal__paragraph">
              We will also retain Usage Data for internal analysis purposes.
              Usage Data is generally retained for a shorter period, except when
              this data is used to strengthen the security or to improve the
              functionality of our Service, or we are legally obligated to
              retain this data for longer time periods.
            </p>
            <h2 className="legal__section-title">7. Transfer of Data</h2>
            <p className="legal__paragraph">
              Your information, including Personal Data, may be transferred to –
              and maintained on – computers located outside of your state,
              province, country or other governmental jurisdiction where the
              data protection laws may differ from those of your jurisdiction.
            </p>
            <p className="legal__paragraph">
              If you are located outside United States and choose to provide
              information to us, please note that we transfer the data,
              including Personal Data, to United States and process it there.
            </p>
            <p className="legal__paragraph">
              Your consent to this Privacy Policy followed by your submission of
              such information represents your agreement to that transfer.
            </p>
            <p className="legal__paragraph">
              Odonto will take all the steps reasonably necessary to ensure that
              your data is treated securely and in accordance with this Privacy
              Policy and no transfer of your Personal Data will take place to an
              organisation or a country unless there are adequate controls in
              place including the security of your data and other personal
              information.
            </p>
            <h2 className="legal__section-title">8. Disclosure of Data</h2>
            <p className="legal__paragraph">
              We may disclose personal information that we collect, or you
              provide:
            </p>
            <h3 className="legal__sub-section-title">
              (a) Disclosure for Law Enforcement.
            </h3>
            <p className="legal__paragraph">
              Under certain circumstances, we may be required to disclose your
              Personal Data if required to do so by law or in response to valid
              requests by public authorities.
            </p>
            <h3 className="legal__sub-section-title">
              (b) Business Transaction.
            </h3>
            <p className="legal__paragraph">
              If we or our subsidiaries are involved in a merger, acquisition or
              asset sale, your Personal Data may be transferred.
            </p>
            <h3 className="legal__sub-section-title">
              (c) Other cases. We may disclose your information also:
            </h3>
            <ul className="list">
              <li className="list-item">to our subsidiaries and affiliates;</li>
              <li className="list-item">
                to contractors, service providers, and other third parties we
                use to support our business;
              </li>
              <li className="list-item">
                to fulfill the purpose for which you provide it;
              </li>
              <li className="list-item">
                for any other purpose disclosed by us when you provide the
                information;
              </li>
              <li className="list-item">
                with your consent in any other cases;
              </li>
              <li className="list-item">
                if we believe disclosure is necessary or appropriate to protect
                the rights, property, or safety of the Company, our customers,
                or others.
              </li>
            </ul>
            <h2 className="legal__section-title">9. Security of Data</h2>
            <p className="legal__paragraph">
              The security of your data is important to us but remember that no
              method of transmission over the Internet or method of electronic
              storage is 100% secure. While we strive to use commercially
              acceptable means to protect your Personal Data, we cannot
              guarantee its absolute security.
            </p>
            <h2 className="legal__section-title">10. Service Providers</h2>
            <p className="legal__paragraph">
              We may employ third party companies and individuals to facilitate
              our Service (“Service Providers”), provide Service on our behalf,
              perform Service-related services or assist us in analysing how our
              Service is used.
            </p>
            <p className="legal__paragraph">
              These third parties have access to your Personal Data only to
              perform these tasks on our behalf and are obligated not to
              disclose or use it for any other purpose.
            </p>
            <h2 className="legal__section-title">11. Analytics</h2>
            <p className="legal__paragraph">
              We may use third-party Service Providers to monitor and analyze
              the use of our Service.
            </p>
            <h3 className="legal__sub-section-title">Vercel Analytics</h3>
            <p className="legal__paragraph">
              Vercel Analytics is a web analytics service provided by Vercel. It
              offers insights into website visitors, including data on top
              visited pages, referrers, and visitor demographics such as
              location, operating systems, and browser information. Vercel
              Analytics ensures visitor privacy by storing only anonymized data
              and not using cookies.
            </p>
            <p className="legal__paragraph">
              For more information on the privacy practices of Vercel, please
              visit the Vercel Privacy Terms web page:
              https://vercel.com/legal/privacy-policy
            </p>
            <h3 className="legal__sub-section-title">Sentry</h3>
            <p className="legal__paragraph">
              Sentry is an error monitoring service that helps us detect,
              diagnose, and resolve issues in our applications. Sentry collects
              data to track and monitor errors in real time, including
              information such as execution traces, variables, software
              versions, and device operating systems. This data assists us in
              understanding the origin of errors, diagnosing problems more
              efficiently, and minimizing the impact on users. Sentry may use
              the collected data to enhance its services and for other purposes
              as outlined in its privacy policy.
            </p>
            <p className="legal__paragraph">
              For more information on the privacy practices of Sentry, please
              visit the Sentry Privacy Terms web page:
              https://sentry.io/privacy/
            </p>
            <h3 className="legal__sub-section-title">PostHog</h3>
            <p className="legal__paragraph">
              PostHog is an analytics platform that analyzes user behavior on
              both web and mobile applications. It tracks user actions such as
              sign-ups and feature interactions to provide insights into user
              engagement. PostHog collects data on user activity across
              different technologies to help us better understand and improve
              our Service.
            </p>
            <p className="legal__paragraph">
              For more information on the privacy practices of PostHog, please
              visit the PostHog Privacy Terms web page:
              https://posthog.com/privacy
            </p>
            <h2 className="legal__section-title">12. CI/CD tools</h2>
            <p className="legal__paragraph">
              We may use third-party Service Providers to automate the
              development process of our Service.
            </p>
            <h3 className="legal__sub-section-title">GitHub</h3>
            <p className="legal__paragraph">
              GitHub is provided by GitHub, Inc.
            </p>
            <p className="legal__paragraph">
              GitHub is a development platform to host and review code, manage
              projects, and build software.
            </p>
            <p className="legal__paragraph">
              For more information on what data GitHub collects for what purpose
              and how the protection of the data is ensured, please visit GitHub
              Privacy Policy page:
              https://help.github.com/en/articles/github-privacy-statement.
            </p>
            <h2 className="legal__section-title">13. Payments</h2>
            <p className="legal__paragraph">
              We may provide paid products and/or services within Service. In
              that case, we use third-party services for payment processing
              (e.g. payment processors).
            </p>
            <p className="legal__paragraph">
              We will not store or collect your payment card details. That
              information is provided directly to our third-party payment
              processors whose use of your personal information is governed by
              their Privacy Policy. These payment processors adhere to the
              standards set by PCI-DSS as managed by the PCI Security Standards
              Council, which is a joint effort of brands like Visa, Mastercard,
              American Express and Discover. PCI-DSS requirements help ensure
              the secure handling of payment information.
            </p>
            <p className="legal__paragraph">
              The payment processors we work with are:
            </p>
            <ul className="list">
              <li className="list-item">
                PayPal or Braintree: Their Privacy Policy can be viewed at
                https://www.paypal.com/webapps/mpp/ua/privacy-full
              </li>
            </ul>
            <h2 className="legal__section-title">14. Links to Other Sites</h2>
            <p className="legal__paragraph">
              Our Service may contain links to other sites that are not operated
              by us. If you click a third party link, you will be directed to
              that third party's site. We strongly advise you to review the
              Privacy Policy of every site you visit.
            </p>
            <p className="legal__paragraph">
              We have no control over and assume no responsibility for the
              content, privacy policies or practices of any third party sites or
              services.
            </p>
            <h2 className="legal__section-title">15. Children's Privacy</h2>
            <p className="legal__paragraph">
              Our Services are not intended for use by children under the age of
              13 (“Children”).
            </p>
            <p className="legal__paragraph">
              We do not knowingly collect personally identifiable information
              from Children under 13. If you become aware that a Child has
              provided us with Personal Data, please contact us. If we become
              aware that we have collected Personal Data from Children without
              verification of parental consent, we take steps to remove that
              information from our servers.
            </p>
            <h2 className="legal__section-title">
              16. Changes to This Privacy Policy
            </h2>
            <p className="legal__paragraph">
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page.
            </p>
            <p className="legal__paragraph">
              We will let you know via email and/or a prominent notice on our
              Service, prior to the change becoming effective and update
              “effective date” at the top of this Privacy Policy.
            </p>
            <p className="legal__paragraph">
              You are advised to review this Privacy Policy periodically for any
              changes. Changes to this Privacy Policy are effective when they
              are posted on this page.
            </p>
            <h2 className="legal__section-title">17. Contact Us</h2>
            <p className="legal__paragraph">
              If you have any questions about this Privacy Policy, please
              contact us:
            </p>
            <ul className="list">
              <li className="list-item">By email: hello@odonto.ph.</li>
              <li className="list-item">
                By visiting this page on our website:
                https://www.odonto.ph/contact-us.
              </li>
            </ul>
          </div>
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default PrivacyPolicy;
